<template>
  <div class="cartDropdown">
    <div class="cartDropdown__inner">
      <template v-if="costCenters.length">
        <v-tabs :navigation="tabsNavigation" :edit-url="false" layout="primary">
          <template #default="{ activeTab }">
            <v-tab v-if="activeTab === 0">
              <template>
                <cartDropdownContent v-if="cartData && cartData.items.length" />
                <cartDropdownEmpty v-else />
              </template>
            </v-tab>
            <v-tab v-if="activeTab === 1"> <cartDropdownCostCenter /> </v-tab>
          </template>
        </v-tabs>
      </template>
      <template v-else>
        <cartDropdownContent v-if="cartData && cartData.items.length" />
        <cartDropdownEmpty v-else />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import costCentersMixin from '~/mixins/costCenters';
import cartMixin from '~/mixins/cart';
import VTabs from '~/components/VTabs/VTabs';
import VTab from '~/components/VTabs/VTab';
import CartDropdownContent from '~/components/CartDropdown/CartDropdownContent';
import CartDropdownEmpty from '~/components/CartDropdown/CartDropdownEmpty';
import CartDropdownCostCenter from '~/components/CartDropdown/CartDropdownCostCenter';

export default {
  name: 'CartDropdown',
  components: {
    VTabs,
    VTab,
    CartDropdownContent,
    CartDropdownEmpty,
    CartDropdownCostCenter,
  },
  mixins: [cartMixin, costCentersMixin],
  data() {
    return {
      tabsNavigation: [{ title: 'Mój koszyk' }, { title: 'Limity - centra kosztowe' }],
      cmsSection: '',
    };
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
  },
  mounted() {
    if (!this.cartData) {
      this.getCart();
    }
  },
};
</script>
<style lang="scss">
.cartDropdown {
  $root: &;
  position: absolute;
  right: -20px;
  top: 80%;
  padding-top: 2.7rem;
  cursor: default;
  opacity: 0;
  pointer-events: none;
  transition: opacity $tr, top $tr;

  @include rwd('ultra') {
    right: -10px;
    padding-top: 2.2rem;
  }

  &__inner {
    position: relative;
    background-color: $cWhite;
    width: 60rem;
    box-shadow: 0 10px 20px rgba(23, 25, 51, 0.1);
    border: 1px solid $cAddLight;
    border-radius: 0 0 4px 4px;

    &:before {
      content: '';
      position: absolute;
      transform: rotate(45deg);
      right: 20px;
      top: -7px;
      width: 12px;
      height: 12px;
      background-color: $cWhite;
      border-left: 1px solid $cAddLight;
      border-top: 1px solid $cAddLight;

      @include rwd('ultra') {
        right: 10px;
      }
    }
  }

  .tabs {
    position: relative;
    top: 0;
    width: 100%;
  }

  .tabs__nav {
    width: 100%;
    border-bottom: 1px solid #f0f1f5;

    &Item {
      flex: 1 1 50%;
      text-align: center;
      background: transparent;
      border: unset;
      transition: background-color $tr;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -1px;
        background-color: $cSec;
        width: 0;
        height: 2px;
        transition: width $tr;
      }

      &:hover {
        &:after {
          width: 100%;
        }
      }

      &--active {
        background: #f7f8fc;

        &:after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -1px;
          background-color: $cSec;
          width: 100%;
          height: 2px;
        }
      }
    }
  }
}
</style>
